import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/cv',
    name: 'cv',
    component: () => lazyLoadView(import('@views/gtk/cv/Cv.vue')),
    meta: {
      title: 'Daftar Riwayat Hidup (CV)',
    },
  },
];
